import React from 'react'

import { Button } from '@barracuda-internal/bds-core'
import { useDomainPolicyAccess } from 'lib/hooks/useDomainPolicyAccess'
import { ModifiedDomainManagerItem } from 'components/pages/domains/useDomainsLogic'

interface DomainModeButtonProps {
  domain: ModifiedDomainManagerItem
  onManageDomain: (e: React.MouseEvent<HTMLButtonElement>, domain: ModifiedDomainManagerItem) => void
  isLoading: boolean
  disabled: boolean
  manageLabel: string
  helpdeskLabel: string
}

export const DomainModeButton: React.FC<DomainModeButtonProps> = ({
  domain,
  onManageDomain,
  isLoading,
  disabled,
  manageLabel,
  helpdeskLabel
}) => {
  const domainId = Number(domain.domainId)
  const { canManageDomainPolicies, canReadDomainPolicies } = useDomainPolicyAccess(domainId)

  if (!Number.isFinite(domainId)) {
    return null
  }

  if (!canManageDomainPolicies && !canReadDomainPolicies) {
    return null
  }

  const label = canManageDomainPolicies ? manageLabel : helpdeskLabel
  return (
    <Button
      variant="text"
      onClick={e => onManageDomain(e, domain)}
      size="small"
      color="primary"
      disabled={disabled}
      isLoading={isLoading}
    >
      {label}
    </Button>
  )
}
